import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=6963aa88&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=6963aa88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963aa88",
  null
  
)

export default component.exports